import {Component, ElementRef, Input, OnInit, Output, Renderer2} from '@angular/core';
import {RewardService} from '../../../shared/services/reward.service';
import {RewardsSummaryService} from '../../../shared/services/rewards-summary.service';
import {RewardsToasterService} from '../../../shared/services/rewards-toaster.service';
import {RewardModel} from '../../../shared/models/data.model';
import {PaginationService} from '../../../shared/services/pagination.service';
import {LoaderService} from '../../../shared/loading-spinner/loading-spinner.service';
import {properties} from '../../../../environments/properties';
import {ParamService} from '../../../shared/services/param.service';
import {AuthService} from "../../../shared/services/auth.service";
import {PointsModalService} from "../../../shared/services/points-modal.service";


// jQuery
declare const $: any;

@Component({
    selector: 'app-get-your-rewards',
    templateUrl: './get-your-rewards.component.html',
    styleUrls: ['./get-your-rewards.component.scss']
})


export class GetYourRewardsComponent implements OnInit {
    public rewards: RewardModel[] = [];
    public hideloadMoreButton = false;
    public sortedRewards: RewardModel[] = [];  // the whole list
    public rewardsSecondary: RewardModel[] = []; // expanded list
    public catigorizePointsTierRewards: { [key: string]: RewardModel[] };
    public currentPointTier: string;
    public currentCounter: { [key: number]: number };
    public count: { [key: number]: number };
    public counter = [];
    public cashReward: RewardModel[] = []; // cash Reward
    public tempCounter = [];
    public showLoading = true;
    public error = false;
    public rewardDetailPath: string;
    public errorMessage: string;
    public dataErrorMessage: string;
    public isAuthenticated = false;
    public rewardsAvailable: number;
    public pointsAvailable: number;
    public rewardPoints: number;
    public rewardsExpire: number;
    public rewardChecked = '';
    public showAsPromo = '';
    public hideCategories = '';
    public promoGridTitle = '';
    public promoGridLabelTitle = '';
    public promoGridLabelLink = '';
    public strPromoTextPlateDisplay = '';
    public strPromoOpenInNewTab = '';
    public strPromoPosition = '';
    public strPromoImageSrc = '';
    public strPromoAltText = '';
    public strPromoLinkPath = '';
    public strPromoTextPlateHeaderText = '';
    public strPromoTextPlateSubText = '';
    public strPromoTextPlateCTAText = '';
    public promoTextPlateDisplay = false;
    public promoOpenInNewTab = false;
    public promoPosition = 0;
    public isLoadMoreActive = false;
    public loadType = '';
    public loadMoreMobileItems = 0;
    public loadMoreTabletItems = 0;
    public loadMoreDesktopItems = 0;
    public rewardToFocus = 0;
    public rewardCardDisabled = false;
    public disableMulticlipRewardGallery: boolean;
    public disableCashReward: boolean;
    public firstTimeInSession: boolean = false;
    private window = window; 
    @Output() isGetYourRewardFlow: boolean = false;
    enableCashReward = true;
    pointScoreCardFlow = true;
    userInfo: any;
    appHostURL: any;
    currentEnvironment: any;
    banner: any;
    rewardsResponseObj;
    autoRewardsPoints: number;
    balance: number;
    dollarDiscount: number;
    willExpire: number;
    isUserHasRewards = false;
    pointsExpiryDate: any;
    points: any;
    rewardsPointsValueDetailsDisplay: any;
    rewardsPointsDateDetailsDisplay: any;
    b4UGalleryData: any;
    tokenCaller = 'get-your-rewards';

    constructor(public _rewardGridService: RewardService,
                private _rewardSummaryService: RewardsSummaryService,
                private paramService: ParamService,
                private authService: AuthService,
                private pointsModalService: PointsModalService) {

        this.disableCashReward = false;
        this.rewardCardDisabled = false;

    }

    ngOnInit() {
        this._init()
    }
    _init() {
        this.banner = this.paramService.banner;
        this.currentEnvironment = this._rewardSummaryService.getEnvironment();
        this.appHostURL = this._rewardSummaryService.getApplicationDomainURL();
        this.getUserInfo();
        setTimeout(function(){
            const backButton = document.getElementById("back-button-pdp") as HTMLElement;
            if(backButton){
                backButton.focus();
            }
            //(document.getElementById("back-button-pdp") as HTMLElement).focus();
        },500)
        if (window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].initAngularSPA) {
            window['AB']['DATALAYER'].initAngularSPA('rewards', 'get-your-rewards');
        }
    }

    getUserInfo() {
        this.authService.getYourRewardsDataSessionData$.subscribe((userInfo) => {
            if (userInfo) {
                this.userInfo = userInfo;
                if (userInfo.isTokenValid) {
                    this.isGetYourRewardFlow = true;
                    this.getPointSummaryData();
                } else {
                    this.authService.redirectToSSO(userInfo.tokenObject);
                }
            } else {
                this.authService.getUserLogedInToken(this.tokenCaller);
            }
        });
    }

    triggerMyListAPI() {
        this.showLoading = true;
            this.getPointSummaryData();
    }

    private getPointSummaryData() {
        let rwdObj = {
            rewards: {
                balance: 0,
                dollarDiscount: 0,
                points: null,
                autoRewardsPoints: 0,
                willExpire: 0,
                isUserHasRewards: false
            }
        };
        const programType = 'BASEPOINTS';
        this._rewardSummaryService.getRewardsScoreCardV3(this.currentEnvironment, programType, this.userInfo).subscribe((data: any) => {
            if (data && data.scorecards && data.scorecards.length > 0) {
                let scoreCard = data.scorecards.find(scorecard => {
                    return scorecard.programType === 'BASEPOINTS';
                });
                if (scoreCard) {
                    this.pointsAvailable = ((scoreCard.balance < 0) ? 0 : scoreCard.balance);
                    if (scoreCard) {
                        rwdObj.rewards.balance = ((scoreCard.balance < 0) ? 0 : scoreCard.balance);
                        rwdObj.rewards.points = scoreCard.points;
                        rwdObj.rewards.dollarDiscount = ((scoreCard.dollarDiscount < 0) ? 0 : scoreCard.dollarDiscount);
                        rwdObj.rewards.autoRewardsPoints = ((scoreCard.autoRewardsPoints < 0) ? 0 : scoreCard.autoRewardsPoints);
                        rwdObj.rewards.willExpire = ((scoreCard.willExpire < 0) ? 0 : scoreCard.willExpire);
                        rwdObj.rewards.isUserHasRewards = true;
                    }
                } else {
                    this.pointsAvailable = 0;
                }
            } else {
                this.pointsAvailable = 0;
            }
            this.rewardsResponseObj = rwdObj;
            this.getSelectedRewardsMulticlip();

        }, error => {
            this.pointsAvailable = 0;
            this.rewardsResponseObj = rwdObj;
            this.getSelectedRewardsMulticlip();
        });
    }

    public getSelectedRewardsMulticlip() {
        if (this._isRegistered()) {
            this.rewardsSecondary = null;
            this.pointsModalService
                .getSelectedRewardsOffersMultiClip(this.userInfo, this.currentEnvironment)
                .subscribe(response => {
                    this.rewardsSecondary = response;
                    this.rewardsSecondary.forEach(reward => {
                        reward.pointsAvailable = this.rewardsResponseObj.rewards.balance;
                        reward.rewardsExpire = this.willExpire;
                    });
                    this.showLoading = false;
                }, error => {
                    this.showLoading = false;
                    this.error = true
                });
        }
    }
    private _isRegistered(): boolean {
        return (this.authService.isTokenValidForSession(this.userInfo));
    }
    
    openRewardsPage() {
        this.window.location.href ='/rewards/dashboard';
    }

    reLoadPage() {
        this._init();
    }
}
